import { createFileRoute } from "@tanstack/react-router";

import AdminLayout from "@/layouts/admin";
import { ErrorPage } from "@/pages/error";

export const Route = createFileRoute("/user")({
  component: RouteComponent,
  errorComponent: ErrorPage,
});

function RouteComponent() {
  return <AdminLayout />;
}
